module.exports = __webpack_public_path__ + "img/1.2.TN.df07a8f6.png";